<div class="content__wrapper">
  @if (showSidebar) {
    <app-nav-menu
      [env]="environment"
      [firstName]="userLite?.firstName || ''"
      [lastName]="userLite?.lastName || ''"
      [isLoggedIn]="isLoggedIn"
      [userToken]="userToken"
      appTitle="Sierra Production"
      (logout)="onLogout()"
      [menuItems]="menuItems"
      [sites]="sites"
      [selectedSiteId]="selectedSiteId"
      (siteChanged)="onSiteChanged($event)"
    />
  }

  <div class="cs-shell">
    @if (showSidebar) {
      <csl-main-header [env]="environment">
        @if (isUnauthorizedPage) {
          <p-message severity="warn"> You are not authorized to access this page. </p-message>
        }
      </csl-main-header>
    }
    <router-outlet></router-outlet>
  </div>

  <p-toast position="bottom-right" key="main" />

  <p-confirmdialog key="general-dialog" [draggable]="false" />

  <p-confirmdialog key="warning-dialog" [draggable]="false" styleClass="wst-confirm-dialog">
    <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
      <div class="flex flex-col items-center p-8 bg-white rounded-xl w-full max-w-lg mx-auto shadow-xl">
        <div class="rounded-full bg-amber-500 text-white inline-flex justify-center items-center h-24 w-24 -mt-20 shadow-lg">
          <i class="pi pi-exclamation-triangle text-5xl"></i>
        </div>
        <span class="font-bold text-2xl text-center mt-6 mb-2 text-gray-800">
          {{ message.header }}
        </span>
        <p class="text-center text-xl leading-relaxed text-gray-700" [innerHTML]="message.message"></p>
        <div class="flex justify-center gap-6 mt-8 w-full">
          <p-button [label]="message.rejectLabel" (click)="onReject()" variant="outlined" styleClass="cs-button-touch" />
          <p-button [label]="message.acceptLabel" (click)="onAccept()" styleClass="cs-button-touch" />
        </div>
      </div>
    </ng-template>
  </p-confirmdialog>
</div>
